import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { integrationQueryKeys } from "@/integration/data/integrationQueryKeys";
import { ErrorResponse } from "@reflag/shared/api";
import {
  LinearConnection,
  PatchLinearConnection,
} from "@reflag/shared/linearConnectionAPI";

export function useLinearPatchMutation() {
  const { org } = useEnvironment();
  const queryClient = useQueryClient();

  return useMutation<
    LinearConnection,
    AxiosError<ErrorResponse>,
    PatchLinearConnection
  >({
    mutationFn: (data: PatchLinearConnection) =>
      api
        .patch<"/orgs/:orgId/linear/connection">(
          `/orgs/${org.id}/linear/connection`,
          data,
        )
        .then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: integrationQueryKeys.linearConnection(org.id),
      });
    },
  });
}
